<script setup lang="ts">
  import { computed } from 'vue'
  import { BasePopup, BaseButton } from '@qic/ui-components'
  import { useI18n } from 'vue-i18n'
  import SimCardIcon from './assets/sim-card.svg'
  import FlashIcon from './assets/flash.svg'
  import MapLocationsIcon from './assets/map-locations.svg'
  import EditPriceIcon from './assets/edit-price.svg'

  interface Emits {
    (e: 'close'): void
    (e: 'buyPolicyClick'): void
  }

  interface InfoCard {
    title: string
    desc: string
    icon: string
    iconAlt: string
  }

  const emit = defineEmits<Emits>()

  const { locale, t } = useI18n()

  const isRtl = computed(() => locale.value === 'ar')

  const infoCards: InfoCard[] = [
    {
      title: t('airalo.pop_up.block_1.header'),
      desc: t('airalo.pop_up.block_1.desc'),
      icon: SimCardIcon,
      iconAlt: 'sim-card-icon',
    },
    {
      title: t('airalo.pop_up.block_2.header'),
      desc: t('airalo.pop_up.block_2.desc'),
      icon: FlashIcon,
      iconAlt: 'flash-icon',
    },
    {
      title: t('airalo.pop_up.block_3.header'),
      desc: t('airalo.pop_up.block_3.desc'),
      icon: MapLocationsIcon,
      iconAlt: 'map-locations-icon',
    },
    {
      title: t('airalo.pop_up.block_4.header'),
      desc: t('airalo.pop_up.block_4.desc'),
      icon: EditPriceIcon,
      iconAlt: 'edit-price-icon',
    },
  ]
  const emitClose = () => {
    emit('close')
  }
  const buyPolicy = (onClose: () => void) => {
    emit('buyPolicyClick')
    onClose()
  }
</script>

<template>
  <BasePopup big :is-rtl="isRtl" @close="emitClose">
    <div class="airalo-popup">
      <h4 class="airalo-popup__title">{{ $t('airalo.pop_up.header') }}</h4>
      <div class="airalo-popup__content">
        <div v-for="(card, index) in infoCards" :key="index" class="airalo-popup__card">
          <img :src="card.icon" :alt="card.iconAlt" class="airalo-popup__card-icon" />
          <div class="airalo-popup__card-inner">
            <h5 class="airalo-popup__card-title">{{ card.title }}</h5>
            <p class="airalo-popup__card-desc">{{ card.desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <template #button="{ onClose }">
      <BaseButton class="airalo-popup__button" icon="none" medium full @click="buyPolicy(onClose)">
        {{ $t('airalo.pop_up.button') }}
      </BaseButton>
    </template>
  </BasePopup>
</template>

<style scoped lang="scss">
  @use './AiraloPopup';
</style>
